import React from "react";
import { Flex, Form, Radio, Select } from "antd";
import { DefaultOptionType } from "antd/es/select";
import { t } from "i18next";
import { EntityDatePicker } from "src/pages/EntityCardPage/fieldComponents/EntityDatePicker";
import { SchedRowType } from "../../../../SchedulingTypes";
import { ZBulkPlanCreation } from "../../BulkPlanCreationTypes";

const fieldName = (name: keyof ZBulkPlanCreation) => name;

export const BulkPlanFields: React.FC = () => {
  const changeStartDateOpts = [
    { value: false, label: t("Keep the current one") },
    {
      value: true,
      label: t("Assign a new one for the selected instances"),
    },
  ];
  const templateTypeOpts: DefaultOptionType[] = [
    {
      value: SchedRowType.plan,
      label: t("Plan"),
    },
    {
      value: SchedRowType.group,
      label: t("Task group"),
    },
    {
      value: SchedRowType.task,
      label: t("Task"),
    },
  ];

  const form = Form.useFormInstance();
  const changeStartDate = Form.useWatch(fieldName("changeStartDate"), form);

  return (
    <Flex vertical gap={16}>
      <Form.Item
        name={fieldName("changeStartDate")}
        label={t(
          "A scheduled task start date has already been assigned in some instance cards:",
        )}
        rules={[{ required: true }]}
      >
        <Radio.Group options={changeStartDateOpts} />
      </Form.Item>
      {changeStartDate && (
        <Form.Item
          name={fieldName("newStartDate")}
          label={t("Planned start date")}
          rules={[{ required: true }]}
        >
          <EntityDatePicker placeholder={t("Date")} />
        </Form.Item>
      )}
      <Form.Item
        name={fieldName("templateEntityType")}
        label={t("Create from template")}
        rules={[{ required: true }]}
      >
        <Select options={templateTypeOpts} placeholder={t("Select")} />
      </Form.Item>
    </Flex>
  );
};
